module.exports = __webpack_public_path__ + "img/confirmed.28528b80.svg";